export function getInitialsFromText(text) {
    const value = text?.trim();
    if (!value) {
        return '?';
    }

    const parts = value.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
        return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }

    return value.slice(0, 2).toUpperCase();
}

export function getUserInitials(user) {
    const displayName = user?.displayName?.trim();
    if (displayName) {
        return getInitialsFromText(displayName);
    }

    const email = user?.email?.trim();
    if (email) {
        return email[0].toUpperCase();
    }

    return '?';
}
